import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SuccessSnackbarComponent } from "../components/snackbars/success-snackbar/success-snackbar.component";
import { ErrorSnackbarComponent } from "../components/snackbars/error-snackbar/error-snackbar.component";

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) {
  }

  public success(message: string, duration = 3500) {
    this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      data: message,
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  public error(message: string, duration = 3500) {
    this.snackBar.openFromComponent(ErrorSnackbarComponent, {
      data: message,
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
